import api from './index';

export const responseHandler = (response: Response) => {
  const type = response.headers.get('Content-Type')?.split(';')[0];
  if (type === 'application/json') return response.json();
  if (type && type.includes('text')) return response.text();
  return response.blob();
};

const assetApi = api.injectEndpoints({
  endpoints: build => ({
    fetchCreativeIdList: build.query({
      query: ({ query }) => ({
        method: 'GET',
        url: `/api/creative-testing/v1/list`,
        params: {
          query,
        },
      }),
      providesTags: [{ type: 'creativeTesting', id: 'LIST' }],
    }),
    fetchAssetsList: build.query({
      query: ({ s3Prefix, adSlot, testType }) => ({
        method: 'GET',
        url: `/api/creative-testing/v1/assets`,
        params: { s3Prefix, adSlot, testType },
        responseHandler,
      }),
    }),
    fetchAsset: build.query({
      query: path => ({
        method: 'GET',
        url: `/api/creative-testing/v1/asset?path=${path}`,
        responseHandler,
      }),
    }),
    fetchMetadata: build.query({
      query: type => ({
        method: 'GET',
        url: `/api/creative-testing/v1/metadata?type=${type}`,
      }),
    }),
    updateCreative: build.mutation({
      query: ({ id, body }) => ({
        method: 'PATCH',
        url: `/api/creative-testing/v1/${id}`,
        body,
      }),
      invalidatesTags: [{ type: 'creativeTesting', id: 'LIST' }],
    }),
    retest: build.mutation({
      query: ({ id, testType }) => ({
        method: 'PATCH',
        url: `/api/creative-testing/v1/retest?id=${id}&testType=${testType}`,
      }),
      invalidatesTags: [{ type: 'creativeTesting', id: 'LIST' }],
    }),
    fetchAdsurePodTests: build.query({
      query: ({ pod, startDate, endDate, sources }) => ({
        method: 'GET',
        url: '/api/creative-testing/v1/pod-tests',
        params: {
          pod,
          ...(startDate ? { startDate } : {}),
          ...(endDate ? { endDate } : {}),
          ...(sources ? { sources } : {}),
        },
      }),
    }),
    fetchMonitoringAnalytics: build.query({
      query: ({ period, startDate, endDate, sources, statuses }) => ({
        method: 'GET',
        url: '/api/creative-testing/v1/monitoring-analytics',
        params: {
          period,
          startDate,
          endDate,
          ...(sources ? { sources } : {}),
          ...(statuses ? { statuses } : {}),
        },
      }),
    }),
    fetchUniqueValues: build.query({
      query: ({ key, source, path, testType }) => ({
        method: 'GET',
        url: `/api/creative-testing/v1/uniqueValues?key=${key}&source=${source}&path=${path}&testType=${testType}`,
      }),
    }),
    fetchNavigationSteps: build.mutation({
      query: ({ adslot }) => ({
        method: 'GET',
        url: `/api/creative-testing/v1/fetchNavigationSteps?adslot=${adslot}`,
      }),
    }),
  }),
});

export const {
  useFetchCreativeIdListQuery,
  useFetchAssetsListQuery,
  useLazyFetchAssetsListQuery,
  useFetchAssetQuery,
  useFetchMetadataQuery,
  useUpdateCreativeMutation,
  useFetchUniqueValuesQuery,
  useRetestMutation,
  useFetchAdsurePodTestsQuery,
  useFetchMonitoringAnalyticsQuery,
  useFetchNavigationStepsMutation,
} = assetApi;
